export default __webpack_public_path__ + "static/media/unstaking-step-three-zen-ust.cbd30268.svg";